import React from "react";
import { connect } from "react-redux";


import "./logSearch.css";

import ApiLogSearch from "./ApiLogs/ApiLogSearch.js";
import OutboundSearch from "./OutboundLogs/OutboundSearch.js";

import { selectLogType } from "../../actions/index";
import DraftEditSearch from "./DraftEditLogs/DraftEditSearch";
import ProcessingSearch from "./ProcessingLogs/ProcessingSearch";
import SheetLogSearch from "./SheetLogs/SheetLogSearch";
// import WarmupLogSearch from "./WarmupLogs/WarmupLogSearch";
// import SmtpLogSearch from "./SmtpLogs/SmtpLogSearch";
import CampaignErrorSearch from "./CampaignErrorLogs/CampaignErrorSearch";
import ExtensionLogSearch from "./ExtensionLogs/ExtensionLogSearch";
import StatusSearch from "./StatusLogs/StatusSearch";
import PushRequestLogSearch from "./SmtpPushRequestLogs/PushRequestLogSearch.js";

export class LogSearch extends React.Component {



    componentDidMount(){
        console.log(this.props)
        if(this.props.logType){
            this.props.selectLogType(this.props.logType)
        }else{
            this.props.selectLogType('api')
        }
    }

    getLogSearchBar = () =>{

        switch(this.props.selectedLogType){
            case 'api':
                return (<ApiLogSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'error':
                return(<CampaignErrorSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'status':
                return(<StatusSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'drafts':
                return(<DraftEditSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'outbound':
                return(<OutboundSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'process':
                return(<ProcessingSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'sheet':
                return(<SheetLogSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            // case 'smtp':
            //     return(<SmtpLogSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'extension':
                    return(<ExtensionLogSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            case 'smtpPush':
                return(<PushRequestLogSearch logTerm={this.props.logTerm} logType={this.props.logType} />)
            default:
                return (<div>Unable to render Search</div>)

        }
    }



    changeLogType = (event) => {
        event.stopPropagation()
        this.props.selectLogType(event.target.value)
    }



    render() {
        return (
            <div className="LogSearch">
                <div className="LogSearch-type">
                    <select name="logType" id="logType" onChange={this.changeLogType} value={this.props.selectedLogType}>
                        <option value="api">API</option>
                        <option value="extension">Extension</option>
                        <option value="error">Errors</option>
                        <option value="status">Status</option>
                        <option value="drafts">Draft Edits</option>
                        <option value="outbound">Outbound</option>
                        <option value="process">Process</option>
                        <option value="sheet">Sheet</option>
                        <option value="warmup">Warmup</option>
                        <option value="smtp">SMTP</option>
                        <option value="smtpPush">SMTP Push Logs</option>      
                        
                    </select>
                </div>
                {this.getLogSearchBar()}
            </div>


        );
    }
}


const mapStateToProps = (state) => {
    return { selectedLogType: state.logs.selectedLogType};
};

export default connect(mapStateToProps,{selectLogType})(LogSearch);
